var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00014 10.17L2.53014 6.70001C2.14014 6.31001 1.51014 6.31001 1.12014 6.70001C0.730137 7.09001 0.730137 7.72001 1.12014 8.11001L5.30014 12.29C5.69014 12.68 6.32014 12.68 6.71014 12.29L17.2901 1.71001C17.6801 1.32001 17.6801 0.690007 17.2901 0.300007C16.9001 -0.0899927 16.2701 -0.0899927 15.8801 0.300007L6.00014 10.17Z",
    fill: "#44C032"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.0d3001488ba7acb295b6bcae9cdf21ba.svg";
export { ForwardRef as ReactComponent };